/* HOTFIX AI models (owner 30-Oct-2026) — EN + AR of the Founder "Configure platform key" dialog (pages/platform/
   PlatformKeyDialog.jsx), the Model line of the Platform key card (pages/platform/AIKeysTab.jsx) and the saved-key texts of
   the firm's own-key dialog (pages/AIUsageProviderKeyCard.jsx).
   No provider name or model id in any text here: the two provider names are proper names written in the Founder dialog
   itself (the Founder / Platform-Admin AI Keys pages are the one place they are allowed). */
export default {
  en: {
    hfai: {
      title: "Configure platform key",
      desc: "The key from the hosting setting is the perpetual safety net — you can switch to a key entered here any time to manage cost, then switch back with zero data loss. A firm's own key (allowed per firm below) is completely independent of this setting.",
      mode: "Mode",
      modeHosting: "Platform key · from hosting setting",
      modeHere: "Platform key · entered here",
      provider: "Provider",
      apiKey: "API key",
      savedPlaceholder: "Saved key …{last4} is used — paste a new key only to replace it",
      savedHint: "The saved key (…{last4}) is used for the model list, the test and the save. It never leaves the server.",
      model: "Model",
      refresh: "Refresh from provider",
      refreshing: "Refreshing…",
      deprecated: "deprecated",
      loadedN: "Loaded {n} models from the provider.",
      loadingSaved: "Loading the models of the saved key…",
      liveNote: "The full list of models this key can use, from the provider.",
      staticNote: "Fallback list — used only until the provider's own list is loaded (paste a key, or a saved key is loaded automatically).",
      pasteFirst: "Paste an API key first, then refresh the model list.",
      noModels: "The provider returned no models.",
      listFailed: "Failed to fetch the model list",
      hiddenTitle: "Not offered ({n}) — AZEX's request would not run on these models:",
      testTitle: "Test key against provider",
      testDesc: "Required before activating or changing the model. The key serves ALL firms on the platform key — it must be verified working first.",
      test: "Test key",
      testing: "Testing…",
      accepted: "Key accepted by provider",
      rejected: "Key rejected",
      testFailed: "Test failed",
      switchBackNote: "Switching back to the hosting-setting key is instant. The key entered here stays encrypted at rest — re-activating it later needs a fresh test but no re-paste.",
      cancel: "Cancel",
      saving: "Saving…",
      testFirst: "Test key first",
      switchHosting: "Switch to the hosting-setting key",
      activate: "Activate the key entered here",
      saveModel: "Save the model (keep the saved key)",
      savedHostingToast: "Switched to the platform key from the hosting setting",
      savedHereToast: "Platform key entered here activated — the next AI call will use it",
      savedModelToast: "Model saved — the next AI call will use it",
      saveFailed: "Save failed",
      loadFailed: "Load failed",
      cardModel: "Model",
      // the firm's own-key dialog (tenant screen: no provider name, no model id)
      firmSavedPlaceholder: "Your saved key (…{last4}) is used — paste a new key only to replace it",
      firmSavedHint: "The test and the save use your firm's saved key. Saving again stores the recommended model; the key is kept.",
    },
  },
  ar: {
    hfai: {
      title: "إعداد مفتاح المنصة",
      desc: "المفتاح المأخوذ من إعداد الاستضافة هو شبكة الأمان الدائمة — يمكنك في أي وقت التحول إلى مفتاح يُدخَل هنا لإدارة التكلفة، ثم العودة دون فقدان أي بيانات. مفتاح الشركة الخاص (المسموح به لكل شركة أدناه) مستقل تمامًا عن هذا الإعداد.",
      mode: "الوضع",
      modeHosting: "مفتاح المنصة · من إعداد الاستضافة",
      modeHere: "مفتاح المنصة · مُدخَل هنا",
      provider: "المزوّد",
      apiKey: "مفتاح API",
      savedPlaceholder: "يُستخدم المفتاح المحفوظ …{last4} — الصق مفتاحًا جديدًا فقط لاستبداله",
      savedHint: "يُستخدم المفتاح المحفوظ (…{last4}) لقائمة النماذج والاختبار والحفظ. ولا يغادر الخادم أبدًا.",
      model: "النموذج",
      refresh: "تحديث من المزوّد",
      refreshing: "جارٍ التحديث…",
      deprecated: "متقادم",
      loadedN: "تم تحميل {n} نموذجًا من المزوّد.",
      loadingSaved: "جارٍ تحميل نماذج المفتاح المحفوظ…",
      liveNote: "القائمة الكاملة للنماذج التي يمكن لهذا المفتاح استخدامها، من المزوّد.",
      staticNote: "قائمة احتياطية — تُستخدم فقط إلى أن تُحمَّل قائمة المزوّد نفسه (الصق مفتاحًا، أو تُحمَّل قائمة المفتاح المحفوظ تلقائيًا).",
      pasteFirst: "الصق مفتاح API أولًا، ثم حدّث قائمة النماذج.",
      noModels: "لم يُرجع المزوّد أي نماذج.",
      listFailed: "تعذّر جلب قائمة النماذج",
      hiddenTitle: "غير معروضة ({n}) — لن يعمل طلب AZEX على هذه النماذج:",
      testTitle: "اختبار المفتاح لدى المزوّد",
      testDesc: "مطلوب قبل التفعيل أو تغيير النموذج. يخدم المفتاح جميع الشركات على مفتاح المنصة — لذا يجب التحقق من عمله أولًا.",
      test: "اختبار المفتاح",
      testing: "جارٍ الاختبار…",
      accepted: "قبِل المزوّد المفتاح",
      rejected: "رُفض المفتاح",
      testFailed: "فشل الاختبار",
      switchBackNote: "العودة إلى مفتاح إعداد الاستضافة فورية. يبقى المفتاح المُدخَل هنا مشفّرًا عند التخزين — وإعادة تفعيله لاحقًا تتطلب اختبارًا جديدًا دون إعادة لصقه.",
      cancel: "إلغاء",
      saving: "جارٍ الحفظ…",
      testFirst: "اختبر المفتاح أولًا",
      switchHosting: "التحول إلى مفتاح إعداد الاستضافة",
      activate: "تفعيل المفتاح المُدخَل هنا",
      saveModel: "حفظ النموذج (مع إبقاء المفتاح المحفوظ)",
      savedHostingToast: "تم التحول إلى مفتاح المنصة من إعداد الاستضافة",
      savedHereToast: "تم تفعيل مفتاح المنصة المُدخَل هنا — سيستخدمه طلب الذكاء الاصطناعي التالي",
      savedModelToast: "تم حفظ النموذج — سيستخدمه طلب الذكاء الاصطناعي التالي",
      saveFailed: "فشل الحفظ",
      loadFailed: "فشل التحميل",
      cardModel: "النموذج",
      firmSavedPlaceholder: "يُستخدم المفتاح المحفوظ لشركتك (…{last4}) — الصق مفتاحًا جديدًا فقط لاستبداله",
      firmSavedHint: "يستخدم الاختبار والحفظ المفتاح المحفوظ لشركتك. يؤدي الحفظ مجددًا إلى تخزين النموذج الموصى به مع إبقاء المفتاح.",
    },
  },
};
